import { render, staticRenderFns } from "./hi-span.vue?vue&type=template&id=072b7759"
import script from "./hi-span.vue?vue&type=script&lang=ts"
export * from "./hi-span.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports